<template>
  <li v-if="session.sessionId" class="headline">
    {{
      session.isPlayerOrSpectator
        ? t('menu.tabs.session.player')
        : t('menu.tabs.session.host')
    }}
  </li>
  <li v-else class="headline">
    {{ t('menu.tabs.session.create') }}
  </li>
  <template v-if="!session.sessionId">
    <li @click="session.hostSession">
      {{ t('menu.storyteller') }}<em>[H]</em>
    </li>
    <li @click="session.joinSession">
      {{ t('menu.player') }}<em>[J]</em>
    </li>
  </template>
  <template v-else>
    <li v-if="session.ping">
      {{ t('menu.delay') }}
      {{ session.isPlayerOrSpectator ? t('menu.host') : t('menu.players') }}
      <em>{{ session.ping }}ms</em>
    </li>
    <li @click="session.copySessionUrl">
      {{ t('menu.link') }}
      <em><font-awesome-icon icon="copy" class="fa fa-copy" /></em>
    </li>
    <li v-if="voiceChat.town?.name" @click="userPreferences.setDiscordName()">
      {{ t('menu.setDiscordName') }}
      <em><small>{{ userPreferences.discordName }}</small> <font-awesome-icon :icon="['fab', 'discord']"
          class="fab fab-discord" /></em>
    </li>
    <li @click="session.leaveSession()">
      {{ t('menu.leave') }}
      <em>{{ userPreferences.isStreamerMode ? "(hidden)" : session.sessionId }}<small
          v-if="voiceChat.town?.name"> ({{ voiceChat.town.name }})</small></em>
    </li>
  </template>
</template>

<script setup lang="ts">
import {
  useLocaleStore,
  useSessionStore,
  useUserPreferencesStore,
  useVoiceChatStore,
} from "@/stores";

const locale = useLocaleStore();
const t = locale.t;
const session = useSessionStore();
const userPreferences = useUserPreferencesStore();
const voiceChat = useVoiceChatStore();
</script>

<style lang="scss" src="./Menu.scss" scoped></style>
